function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import './payment-form.scss';
import React, { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { useDispatch, useSelector } from 'react-redux';
import { BANK_TRANSFER, CREDITS, FREE } from 'researcher/domain/transaction/payment-method';
import { Controls } from 'shared/helper/form';
import { T, useTranslate } from 'shared/helper/translate';
import { convertFormAddressToJson } from 'shared/view/address-conversion-service';
import { paymentMethodReady, persistPayment, save, saveFailed, updateFormData, updatePaymentCurrencies } from '../actions';
import { getAddressFieldDisplaySettings, getFapiaoFormVisible, getInvoiceAddressAvailable, getInvoiceAddressFieldDisplaySettings, getPaymentMethodRequiresBillingInformation, getSelectableCountries, getUsingBrazilianPaymentMethod } from '../reducer';
import AllpagoPaypalForm, { defaultValues as allpagoPaypalDefaultValues } from './AllpagoPaypalForm';
import BillingAndInvoiceAddress from './BillingAndInvoiceAddress';
import BoletoForm, { defaultValues as boletoDefaultValues } from './BoletoForm';
import BrazilPaymentMethodsRequirementForm from './BrazilPaymentMethodsRequirementForm';
import CreditCardForm from './CreditCardForm';
import CreditPaymentOptions from './CreditPaymentOptions';
import FapespProcessNumber from './FapespProcessNumber';
import FapiaoForm, { defaultValues as fapiaoDefaultValues } from './FapiaoForm';
import FapiaoRequirementForm from './FapiaoRequirementForm';
import PaymentDetailsSection from './PaymentDetailsSection';
import PaymentMethodSelection from './PaymentMethodSelection';
import PurchaseOrderForm, { defaultValues as purchaseOrderDefaultValues } from './PurchaseOrderForm';
import { defaultValues as addressDefaultValues } from './AddressForm';
import { defaultValues as allpagoCreditCardDefaultValues } from './AllpagoCreditCardForm';
import { defaultValues as creditCardDefaultValues } from './BraintreeCreditCardForm';
var Form = Controls.Form;
var defaultValues = {
  acceptedTermsAndConditions: false,
  additionalData: {},
  allpagoCreditCard: allpagoCreditCardDefaultValues,
  allpagoPaypal: allpagoPaypalDefaultValues,
  amount: 0,
  billingAddress: addressDefaultValues,
  boleto: boletoDefaultValues,
  brazilPaymentMethods: 'no-requirements',
  creditCard: creditCardDefaultValues,
  creditsApplied: 0,
  fapespNumber: '',
  fapiao: fapiaoDefaultValues,
  fapiaoRequirementConfirmed: '',
  invoiceAddress: addressDefaultValues,
  invoiceAddressDiffersFromBilling: false,
  paymentMethodId: '',
  prepaymentApplied: 0,
  prepaymentOption: '',
  purchaseOrder: purchaseOrderDefaultValues,
  receiptCode: '',
  requestAllpago: false,
  requireFapiao: false,
  useCredits: 'yes',
  usingFapespFunds: false,
  voucherApplied: null
};
var PaymentForm = function PaymentForm(_ref) {
  var additionalData = _ref.additionalData,
    _ref$additionalPaymen = _ref.additionalPaymentFilteringOptions,
    AdditionalPaymentFilteringOptions = _ref$additionalPaymen === void 0 ? function () {
      return null;
    } : _ref$additionalPaymen,
    _ref$bankTransferDisa = _ref.bankTransferDisabled,
    bankTransferDisabled = _ref$bankTransferDisa === void 0 ? false : _ref$bankTransferDisa,
    buttonTitle = _ref.buttonTitle,
    children = _ref.children,
    _ref$convertNumberOfI = _ref.convertNumberOfInstallments,
    convertNumberOfInstallments = _ref$convertNumberOfI === void 0 ? false : _ref$convertNumberOfI,
    currency = _ref.currency,
    excludePaymentMethods = _ref.excludePaymentMethods,
    _ref$fapiaoSelectionD = _ref.fapiaoSelectionDisabled,
    fapiaoSelectionDisabled = _ref$fapiaoSelectionD === void 0 ? false : _ref$fapiaoSelectionD,
    formRef = _ref.formRef,
    _ref$hideInvoiceAddre = _ref.hideInvoiceAddress,
    hideInvoiceAddress = _ref$hideInvoiceAddre === void 0 ? false : _ref$hideInvoiceAddre,
    isChinaUser = _ref.isChinaUser,
    orderIdentity = _ref.orderIdentity,
    originalTotal = _ref.originalTotal,
    paymentsEndpoint = _ref.paymentsEndpoint,
    _ref$prepaymentAndCre = _ref.prepaymentAndCreditsEnabled,
    prepaymentAndCreditsEnabled = _ref$prepaymentAndCre === void 0 ? false : _ref$prepaymentAndCre,
    receiptCode = _ref.receiptCode,
    submitDisabled = _ref.submitDisabled,
    total = _ref.total,
    verifyVoucher = _ref.verifyVoucher;
  var methods = useForm({
    defaultValues: defaultValues,
    shouldFocusError: false
  });
  var dispatch = useDispatch();
  var _methods$watch = methods.watch(['creditCard', 'paymentMethodId', 'requireFapiao', 'creditsApplied', 'prepaymentApplied', 'voucherApplied', 'suppressInvoiceCreation']),
    _methods$watch2 = _slicedToArray(_methods$watch, 7),
    creditCard = _methods$watch2[0],
    paymentMethodId = _methods$watch2[1],
    requireFapiao = _methods$watch2[2],
    creditsApplied = _methods$watch2[3],
    prepaymentApplied = _methods$watch2[4],
    voucherApplied = _methods$watch2[5],
    suppressInvoiceCreation = _methods$watch2[6];
  var addressFieldDisplaySettings = getAddressFieldDisplaySettings({
    paymentMethodId: paymentMethodId,
    requireFapiao: requireFapiao
  });
  var userCountry = useSelector(function (_ref2) {
    var user = _ref2.user;
    return user ? user.country : null;
  });
  var allowsFapiaoProcessingAfterPayment = useSelector(function (_ref3) {
    var application = _ref3.application;
    return application.currentLocalization.allowsFapiaoProcessingAfterPayment;
  });
  var selectableCountries = useSelector(function (_ref4) {
    var payment = _ref4.payment;
    return getSelectableCountries({
      paymentMethodId: paymentMethodId,
      payment: payment
    });
  });
  var fapiaoFormVisible = useSelector(function (_ref5) {
    var user = _ref5.user,
      application = _ref5.application;
    return getFapiaoFormVisible({
      paymentMethodId: paymentMethodId,
      requireFapiao: requireFapiao,
      user: user,
      application: application
    });
  });
  var invoiceAddressAvailable = getInvoiceAddressAvailable({
    paymentMethodId: paymentMethodId,
    hideInvoiceAddress: hideInvoiceAddress
  });
  var invoiceAddressFieldDisplaySettings = getInvoiceAddressFieldDisplaySettings({
    paymentMethodId: paymentMethodId,
    requireFapiao: requireFapiao
  });
  var paymentRequiresBillingInformation = getPaymentMethodRequiresBillingInformation({
    paymentMethodId: paymentMethodId
  });
  var showBankTransferDownloadWarning = useSelector(function (_ref6) {
    var user = _ref6.user;
    return paymentMethodId === BANK_TRANSFER && !user.overrideDownloadAvailable;
  });
  var usingBrazilianPaymentMethod = getUsingBrazilianPaymentMethod({
    paymentMethodId: paymentMethodId
  });
  var _useTranslate = useTranslate(),
    t = _useTranslate.t;
  var _useState = useState({}),
    _useState2 = _slicedToArray(_useState, 2),
    preProcessors = _useState2[0],
    setPreProcessors = _useState2[1];
  var bankTransferSupportLink = '/support/index/type/prepay-bank-transfer';
  var displayPaymentDetails = paymentMethodId && [CREDITS, FREE].indexOf(paymentMethodId) === -1;
  var displayBankTransferNotice = displayPaymentDetails && bankTransferDisabled && paymentMethodId === 9;
  var displayStandardPaymentDetails = displayPaymentDetails && !displayBankTransferNotice && paymentRequiresBillingInformation;
  var registerPreProcessor = function registerPreProcessor(paymentMethodId, fn) {
    setPreProcessors(_objectSpread(_objectSpread({}, preProcessors), {}, _defineProperty({}, paymentMethodId, fn)));
  };
  var removeFapiao = function removeFapiao(paymentMethod) {
    var fapiaoPaymentMethods = ['alipay', 'purchase-order', 'union-pay'];
    if (fapiaoPaymentMethods.indexOf(paymentMethod.identity) === -1) {
      methods.resetField('requireFapiao');
    }
  };
  var setPaymentMethod = function setPaymentMethod(paymentMethod) {
    if (!paymentMethod) {
      methods.resetField('paymentMethodId');
      return;
    }
    methods.setValue('paymentMethodId', paymentMethod.id);
    if (userCountry === 'CN' || paymentMethod.identity === 'free') {
      removeFapiao(paymentMethod);
    }

    // Handle loading status for non-credit cards
    if (['credit-card', 'allpago-credit-card'].indexOf(paymentMethod.identity) === -1) {
      dispatch(paymentMethodReady(paymentMethod));
    }
  };
  var handlePersistPayment = function handlePersistPayment(endpoint, orderIdentity, data) {
    var noop = function noop(data) {
      return new Promise(function (resolve) {
        return resolve(data);
      });
    };
    var preProcessor = preProcessors[data.paymentMethodId] || noop;
    var paymentData = _objectSpread(_objectSpread({}, data), {}, {
      billingAddress: convertFormAddressToJson(data.billingAddress),
      invoiceAddress: convertFormAddressToJson(data.invoiceAddress)
    });
    dispatch(save());
    preProcessor(paymentData).then(function (data) {
      return dispatch(persistPayment(endpoint, orderIdentity, data));
    }).catch(function (err) {
      return dispatch(saveFailed(err));
    });
  };
  var resetVoucher = function resetVoucher() {
    return ['voucherApplied', 'prepaymentOption'].map(function (field) {
      return methods.setValue(field, defaultValues[field]);
    });
  };
  var resetPrepayment = function resetPrepayment() {
    return ['prepaymentApplied', 'prepaymentOption'].map(function (field) {
      return methods.setValue(field, defaultValues[field]);
    });
  };
  var resetCredits = function resetCredits() {
    return ['creditsApplied', 'useCredits'].map(function (field) {
      return methods.setValue(field, defaultValues[field]);
    });
  };
  useEffect(function () {
    dispatch(updateFormData({
      creditCard: creditCard,
      paymentMethodId: paymentMethodId,
      creditsApplied: creditsApplied,
      prepaymentApplied: prepaymentApplied,
      voucherApplied: voucherApplied
    }));
  }, [paymentMethodId, creditsApplied, prepaymentApplied, voucherApplied, creditCard.currency.value]);
  useEffect(function () {
    methods.setValue('additionalData', additionalData);
    methods.setValue('amount', total);
    methods.setValue('receiptCode', receiptCode);
    dispatch(updatePaymentCurrencies());
    return function () {
      dispatch(updateFormData(defaultValues));
      resetPrepayment();
      resetCredits();
      resetVoucher();
      ['paymentMethodId', 'allpagoCreditCard.numberOfInstallments.value'].map(function (field) {
        return methods.resetField(field);
      });
    };
  }, []);
  useEffect(function () {
    if (paymentMethodId === BANK_TRANSFER) {
      methods.setValue('invoiceAddressDiffersFromBilling', true);
    }
  }, [paymentMethodId]);
  useEffect(function () {
    methods.setValue('additionalData', additionalData);
  }, [JSON.stringify(additionalData)]);
  useEffect(function () {
    methods.setValue('receiptCode', receiptCode);
  }, [receiptCode]);
  useEffect(function () {
    methods.setValue('amount', total);
  }, [total]);
  return /*#__PURE__*/React.createElement(Form, {
    className: "payment-form",
    methods: methods,
    formRef: formRef,
    onSubmit: function onSubmit(data) {
      return handlePersistPayment(paymentsEndpoint, orderIdentity, data);
    },
    testAttribute: "payment-form"
  }, /*#__PURE__*/React.createElement("h1", null, /*#__PURE__*/React.createElement(T, {
    source: "Payment details"
  })), prepaymentAndCreditsEnabled && (!suppressInvoiceCreation || voucherApplied) ? /*#__PURE__*/React.createElement(CreditPaymentOptions, {
    currency: currency,
    disabled: submitDisabled,
    originalTotal: originalTotal,
    resetCredits: resetCredits,
    resetPrepayment: resetPrepayment,
    resetVoucher: resetVoucher,
    setPaymentMethod: setPaymentMethod,
    total: total,
    verifyVoucher: verifyVoucher
  }) : null, total <= 0 ? /*#__PURE__*/React.createElement("div", {
    className: "alert alert-info"
  }, /*#__PURE__*/React.createElement(T.md, {
    inline: true,
    source: "paid-order-notice",
    params: {
      buttonTitle: t(buttonTitle)
    }
  })) : null, /*#__PURE__*/React.createElement(FapiaoRequirementForm, {
    fapiaoSelectionDisabled: fapiaoSelectionDisabled,
    total: total
  }), /*#__PURE__*/React.createElement(BrazilPaymentMethodsRequirementForm, {
    total: total
  }), /*#__PURE__*/React.createElement(AdditionalPaymentFilteringOptions, {
    currency: currency,
    total: total
  }), allowsFapiaoProcessingAfterPayment ? /*#__PURE__*/React.createElement(T.md, {
    source: "fapiao-after-payment-notice",
    linkRenderer: function linkRenderer(_ref7) {
      var href = _ref7.href,
        children = _ref7.children;
      return /*#__PURE__*/React.createElement("a", {
        href: href,
        target: "_blank",
        rel: "noopener noreferrer"
      }, children);
    }
  }) : null, /*#__PURE__*/React.createElement(PaymentMethodSelection, {
    displayBankTransferNotice: displayBankTransferNotice,
    excludePaymentMethods: excludePaymentMethods,
    fapiaoSelectionDisabled: fapiaoSelectionDisabled,
    setPaymentMethod: setPaymentMethod,
    total: total
  }), displayBankTransferNotice ? /*#__PURE__*/React.createElement(PaymentDetailsSection, null, /*#__PURE__*/React.createElement("div", {
    className: "alert alert-warning mb-4 mt-3"
  }, /*#__PURE__*/React.createElement(T.md, {
    source: "prepay-bank-transfer-notice",
    params: bankTransferSupportLink
  }))) : null, displayStandardPaymentDetails ? /*#__PURE__*/React.createElement(PaymentDetailsSection, null, showBankTransferDownloadWarning ? /*#__PURE__*/React.createElement("div", {
    className: "pb-2"
  }, /*#__PURE__*/React.createElement(T.md, {
    source: "bank-transfer-download-warning"
  })) : null, /*#__PURE__*/React.createElement(FapespProcessNumber, null), /*#__PURE__*/React.createElement(BillingAndInvoiceAddress, {
    addressFieldDisplaySettings: addressFieldDisplaySettings,
    includePhoneNumberDescription: fapiaoFormVisible,
    invoiceAddressAvailable: invoiceAddressAvailable,
    invoiceAddressFieldDisplaySettings: invoiceAddressFieldDisplaySettings,
    isChinaUser: isChinaUser,
    selectableCountries: selectableCountries,
    usingBrazilianPaymentMethod: usingBrazilianPaymentMethod
  }), /*#__PURE__*/React.createElement(CreditCardForm, {
    convertNumberOfInstallments: convertNumberOfInstallments,
    currency: currency,
    receiptCode: receiptCode,
    registerPreProcessor: registerPreProcessor,
    total: total,
    userCountry: userCountry
  }), /*#__PURE__*/React.createElement(FapiaoForm, {
    fapiaoFormVisible: fapiaoFormVisible
  }), /*#__PURE__*/React.createElement(PurchaseOrderForm, {
    paymentMethodId: paymentMethodId,
    isChinaUser: isChinaUser
  }), /*#__PURE__*/React.createElement(BoletoForm, {
    paymentMethodId: paymentMethodId
  }), /*#__PURE__*/React.createElement(AllpagoPaypalForm, {
    paymentMethodId: paymentMethodId
  })) : null, children);
};
export default PaymentForm;